import { IItem, instanceOfIItem } from "./IItem";
import { InjectedRule } from "./InjectedRule";

export interface IRuleInjectable extends IItem {
  injectedRule: InjectedRule;
}

export function instanceOfIRuleInjectable(instance: any): instance is IRuleInjectable {
  return instance
    && (instance.injectedRule !== undefined)
    && instanceOfIItem(instance);
}
